import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckHistoryTemplates } from '@api/consistencyCheckParameters';

import { extractQueryParams } from '@utils/common';
import { mapDropdownOptions } from '@utils/formatter';

import { IId } from '@interfaces/common/common';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_CHECK_HISTORY_TEMPLATES } from '@constants/queryKeys';

interface IUseConsistencyCheckHistoryTemplatesReturned {
	consistencyCheckTemplates: TSelectOption[];
	isLoadingConsistencyCheckHistoryTemplates: boolean;
}

const useConsistencyCheckHistoryTemplates = ({ id }: IId): IUseConsistencyCheckHistoryTemplatesReturned => {
	const {
		data,
		isInitialLoading,
		isFetching,
	} = useQuery({
		queryKey: [CONSISTENCY_CHECK_HISTORY_TEMPLATES, { id }],
		queryFn: extractQueryParams(getConsistencyCheckHistoryTemplates),
		select: (data) => mapDropdownOptions({
			items: data,
			valueKey: 'id',
			labelKey: 'name',
		}),
		enabled: [!!id],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		consistencyCheckTemplates: data || [],
		isLoadingConsistencyCheckHistoryTemplates: isInitialLoading || isFetching,
	};
};

export default useConsistencyCheckHistoryTemplates;
